import React from 'react'
import { Spinner } from '@blueprintjs/core'
import { quarks } from 'ui-components'
import styled from 'styled-components'
const TableLoading = () => <StyledSpinner size={100} />

const StyledSpinner = styled(Spinner)({
  marginTop: quarks.margins.huge,
})

export default TableLoading
